<template>
  <div class="communication">
    <div class="title row column-s">
      <div class="grid-9 grid-12-s text-center-s">COMUNICADO {{comm.nome}}</div>
    </div>

    <Comm v-if="!loader && comm.id" :comm="comm" @file="(f) => file = f" />

    <div v-else class="column align-center justify-center">
      <Loader />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loader from "@/components/Loader.vue";
import Comm from "@/components/Comm.vue";

export default {
  name: "Communication",
  components: { Loader, Comm },
  data() {
    return {
      loader: false,
      comm: {}
    };
  },
  beforeMount() {
    this.GET_COMM(this.$route.params.id).then(r => {
      if (r.data.id_arquivo) {
        this.GET_TEMPLATE(r.data.id).then(file => {
          r.data.template = file.data;
          this.comm = r.data;
          this.loader = false;
        });
      } else {
        this.comm = r.data;
        this.loader = false;
      }
    });
  },
  methods: {
    ...mapActions("admin", ["GET_COMM", "GET_TEMPLATE"])
  },
  mounted() {
    this.$parent.$children[0].changeMenu("communication");
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.communication {
  padding: 42px 35px;
  @media (max-width: $small) {
    padding: 7px;
  }

  .title {
    font-size: 26px;
    font-weight: bold;
    color: $gray-4;
    text-transform: uppercase;

    @media (max-width: $small) {
      margin-top: 38px;
      margin-bottom: 0px;
    }
  }

  .white {
    @media (max-width: $small) {
      margin-top: 1.2rem;
    }
  }
}
</style>